import { metaAI } from "neql"
import React, { FC } from "react"
import {
    AIModelForApp,
    hasActiveAssignment,
    hasInactiveAssignment
} from "../../../../../../../../Models/API/AIModel"

interface AIModelStatusProps {
    model: AIModelForApp
    className?: string
}

export const AIModelStatus: FC<AIModelStatusProps> = ({ model, className }) => {
    const status =
        model.deployment?.status ??
        metaAI.Meta_Ai_Deployment_Status_Enum.Unknown

    if (status !== metaAI.Meta_Ai_Deployment_Status_Enum.Online) {
        return (
            <span className={`${className} text-smoke-610 capitalize`}>
                {status.toLowerCase()}
            </span>
        )
    }

    if (hasActiveAssignment(model)) {
        return (
            <span className={`text-java-400 ${className ?? ""}`}>
                {hasInactiveAssignment(model) ? "Partly active" : "Active"}
            </span>
        )
    }

    return <span className={`${className} text-smoke-610`}>Inactive</span>
}
